import { render, staticRenderFns } from "./voucher-setting.vue?vue&type=template&id=39e365c8&lang=html&"
import script from "./voucher-setting.vue?vue&type=script&lang=js&"
export * from "./voucher-setting.vue?vue&type=script&lang=js&"
import style0 from "./voucher-setting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports